module.exports = __webpack_public_path__ + "img/trashcan.59ae739d.png";